import { createAsyncThunk } from "@reduxjs/toolkit";
import { createAPI } from "services/api/api";
import { editUser, logInAccount, logOutAccount, setError, setIsAuthLoading, setNotifications } from "store/user";
import { setPopup } from "store/popups";
import Cookies from "js-cookie";

const api = createAPI();
const token = Cookies.get('token');

export const loginRequest = createAsyncThunk('user/login', async (userData, { dispatch }) => {
  try {
    const user = await api.post(`/user/login`, userData);

    const balance = await api.get(`/me/get_balance`, {headers: {Authorization: `Bearer ${user.data.token}`}});

    dispatch(logInAccount({ user: user.data.user, token: user.data.token, balance: balance.data.balance }));
    dispatch(setPopup('close'));
  } catch (error) {
    dispatch(setIsAuthLoading(false));
    dispatch(setError(error.message));
  } finally {
    dispatch(setIsAuthLoading(false));
  }
});

export const registerRequest = createAsyncThunk('user/register', async (userData, { dispatch }) => {
  await api.post(`/auth/register`, userData)
    .then((response) => {
      dispatch(setIsAuthLoading(false))
      dispatch(logInAccount({ user: response.data.user, token: response.data.token }));
      dispatch(setIsAuthLoading(false))
      dispatch(setPopup('close'));
    })
    .catch((error) => {
      dispatch(setIsAuthLoading(false))
      dispatch(setError(error.response.data));
    });
});

export const logoutRequest = createAsyncThunk('user/logout', async ({ dispatch }) => {
  dispatch(logOutAccount())
})

export const notificationsRequest = createAsyncThunk(
  'user/getNotifications',
  async (_, { dispatch }) => {
    try {
      const response = await api.get(`/me/notification`);
      dispatch(setNotifications(response.data));
      return response.data;
    } catch (error) {
      console.error("Error fetching notifications:", error);
      throw error;
    }
  }
);

export const clearNotificationsRequest = createAsyncThunk(
  'user/clearAllNotifications',
  async (_, { dispatch }) => {
    try {
      const response = await api.put(`/me/notification/clear/param?clear_all=1`);
      dispatch(setNotifications(response.data));
      return response.data;
    } catch (error) {
      console.error("Error fetching notifications:", error);
      throw error;
    }
  }
);

export const clearOneNotificationRequest = createAsyncThunk(
  'user/clearAllNotifications',
  async (id) => {
    try {
      api.put(`/me/notification/clear/param?notification_ids=${id}`);
    } catch (error) {
      console.error("Error fetching notifications:", error);
      throw error;
    }
  }
);

export const getBalanceRequest = createAsyncThunk('user/getBalance',
  async (_, {dispatch}) => {
    if(token) {
      try {
        api.get('/me/get_balance')
        .then((response) => {
          dispatch(editUser({field: 'balance', value: response.data.balance.toFixed(2)}))
          dispatch(editUser({field: 'user_wallet', value: response.data.user_wallet}))
        })
      } catch (error) {
        console.error("Error fetching balance:", error);
        throw error;
      }
    }
  }
)
